__turbopack_context__.v({
  "Copyright": "Grjkva_Copyright",
  "am4": "Grjkva_am4",
  "assinaturaAM4": "Grjkva_assinaturaAM4",
  "dFlex": "Grjkva_dFlex",
  "footer": "Grjkva_footer",
});
